// YMM Home Search Widget V4 – Multi-tag URL format
(function(){
  var root = document.getElementById('ymm-search-home');
  if(!root) return;
  
  var config = {
    visibleFields: parseInt(root.dataset.visibleFields, 10) || 3,
    visibleFieldsMobile: parseInt(root.dataset.visibleFieldsMobile, 10) || 3,
    onlyWithFitments: root.dataset.onlyWithFitments === 'true',
    buttonText: root.dataset.buttonText || 'SEARCH',
    collectionHandle: root.dataset.collectionHandle || 'all',
    buttonColor: '#FFA500',
    buttonTextColor: '#000000'
  };
  
  // Determine which visible fields count to use based on screen size
  var isMobile = window.innerWidth <= 768;
  var activeVisibleFields = isMobile ? config.visibleFieldsMobile : config.visibleFields;
  
  /* ============================================================
     CSS — Juggernaut USA Theme
     Black background, orange accents, Oswald/Barlow fonts
     Form only, no product grid
     ============================================================ */
  var css = ''

    /* ── Root / Container ── */
    + '#ymm-search-home { width:100%; font-family:"Barlow","Helvetica Neue",Arial,sans-serif; color:#fff; margin:0; padding:0; box-sizing:border-box; background:transparent; position:relative; }'
    + '.ymm-home-container { width:100%; max-width:100%; margin:0 auto; padding:0; position:relative; z-index:1; }'
    + '.sr-only { position:absolute; width:1px; height:1px; padding:0; margin:-1px; overflow:hidden; clip:rect(0,0,0,0); white-space:nowrap; border:0; }'

    /* ── Header ── */
    + '.ymm-home-top-row { text-align:center; margin-bottom:24px; }'
    + '.ymm-home-heading { font-family:"Oswald","Impact","Arial Black",sans-serif; font-size:clamp(22px,3vw,32px); font-weight:700; letter-spacing:4px; text-transform:uppercase; color:#fff; margin:0 0 8px; line-height:1.2; }'
    + '.ymm-home-description { font-size:15px; color:#B0B0B0; letter-spacing:1px; text-align:center; margin:0 0 28px; }'
    + '.ymm-home-description strong { color:#FFA500; font-weight:700; }'

    /* ── Search Form ── */
    + '.ymm-home-search-wrap { margin:0; background:transparent; border:none; border-radius:0; padding:0; width:100%; }'
    + '.ymm-home-fields { display:flex; flex-wrap:wrap; gap:12px; align-items:end; width:100%; }'
    + '@media(max-width:768px) { .ymm-home-fields { flex-direction:column; align-items:stretch; } }'

    /* ── Field Wraps & Selects ── */
    + '.ymm-home-field-wrap { position:relative; display:flex; flex-direction:column; gap:6px; flex:1; min-width:150px; }'
    + '@media(max-width:768px) { .ymm-home-field-wrap { min-width:100%; flex:none; } }'
    + '.ymm-home-field-wrap.hidden { display:none; }'
    + '.ymm-home-field-wrap label { font-family:"Barlow Condensed","Arial Narrow",sans-serif; font-size:11px; letter-spacing:2px; text-transform:uppercase; color:#B0B0B0; font-weight:600; }'
    + '.ymm-home-field-wrap select {'
    +   'width:100%; appearance:none; -webkit-appearance:none;'
    +   'background:#1A1A1A; border:1px solid rgba(255,255,255,0.15); border-radius:4px;'
    +   'color:#fff; font-family:"Barlow","Helvetica Neue",Arial,sans-serif; font-size:15px;'
    +   'padding:14px 40px 14px 16px; cursor:pointer;'
    +   'transition:border-color 0.25s cubic-bezier(0.4,0,0.2,1), box-shadow 0.25s cubic-bezier(0.4,0,0.2,1);'
    +   'background-image:url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'12\' height=\'8\' fill=\'none\'%3E%3Cpath d=\'M1 1.5L6 6.5L11 1.5\' stroke=\'%23FFA500\' stroke-width=\'2\' stroke-linecap=\'round\'/%3E%3C/svg%3E");'
    +   'background-repeat:no-repeat; background-position:right 14px center;'
    + '}'
    + '.ymm-home-field-wrap select:hover, .ymm-home-field-wrap select:focus { border-color:#FFA500; outline:none; box-shadow:0 0 0 2px rgba(255,165,0,0.25); }'
    + '.ymm-home-field-wrap select:disabled { opacity:0.4; cursor:not-allowed; }'
    + '.ymm-home-field-wrap select option { background:#1A1A1A; color:#fff; }'
    + '.ymm-home-field-wrap > svg { display:none; }'

    /* ── Search Button ── */
    + '.ymm-home-btn {'
    +   'display:flex; align-items:center; justify-content:center; gap:8px;'
    +   'background:#FFA500; color:#000 !important;'
    +   'font-family:"Oswald","Impact",sans-serif; font-size:16px; font-weight:700;'
    +   'letter-spacing:2px; text-transform:uppercase;'
    +   'padding:14px 32px; border:none; border-radius:4px; cursor:pointer;'
    +   'transition:all 0.25s cubic-bezier(0.4,0,0.2,1); white-space:nowrap; height:fit-content;'
    +   'flex-shrink:0; align-self:flex-end;'
    + '}'
    + '@media(max-width:768px) { .ymm-home-btn { width:100%; align-self:stretch; margin-top:8px; } }'
    + '.ymm-home-btn:hover:not(:disabled) { background:#E89400; transform:translateY(-2px); }'
    + '.ymm-home-btn:active:not(:disabled) { transform:translateY(0); }'
    + '.ymm-home-btn:disabled { opacity:0.4; cursor:not-allowed; transform:none; }'
    /* Pin the ENABLED state to full-strength brand orange. The disabled rule
       drops opacity to 0.4 and `transition:all` eases it back, so anything that
       left the button part-way — an interrupted transition, an inherited opacity,
       a stacking-context parent — showed as a washed-out amber instead of #FFA500.
       Stating the active state explicitly means it can't land anywhere else. */
    + '.ymm-home-btn:not(:disabled) { background:#FFA500; opacity:1; }'
    + '.ymm-home-btn svg { width:18px; height:18px; }'

    /* ── Error State ── */
    + '.ymm-home-error { padding:20px; text-align:center; color:#EF4444; background:rgba(239,68,68,0.1); border:1px solid rgba(239,68,68,0.3); border-radius:4px; margin:20px 0; font-size:14px; }'
  ;
  
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);
  
  // Fetch configuration and fields
  var shop = window.Shopify && window.Shopify.shop ? window.Shopify.shop : '';
  var apiUrl = '/apps/ymm/config' + (shop ? '?shop=' + encodeURIComponent(shop) : '');
  
  fetch(apiUrl)
    .then(function(response){
      if(!response.ok) throw new Error('Config fetch failed');
      return response.json();
    })
    .then(function(data){
      if (data.buttonColor) config.buttonColor = data.buttonColor;
      if (data.buttonTextColor) config.buttonTextColor = data.buttonTextColor;

      // Restore a previously-entered vehicle (e.g., navigating back to the
      // home page) so the dropdowns come pre-filled instead of blank.
      var savedVehicle = null;
      try {
        var raw = sessionStorage.getItem('ymm_vehicle_selection');
        if(raw) savedVehicle = JSON.parse(raw);
      } catch(e){}

      initializeWidget(data.fields || [], savedVehicle);
    })
    .catch(function(error){
      root.innerHTML = '<div class="ymm-home-error">Unable to load vehicle search. Please try again later.</div>';
    });
  
  function initializeWidget(fields, cachedSelection){
    if(!fields || fields.length === 0){
      root.innerHTML = '<div style="padding:20px;text-align:center;color:rgba(255,255,255,0.6)">No vehicle fields configured. Please configure fields in the app settings.</div>';
      return;
    }
    
    var savedSelection = cachedSelection;
    
    var html = '<div class="ymm-home-container">';
    
    /* ── Search Form ONLY ── */
    html += '<form class="ymm-home-search-wrap" role="search" aria-label="Search parts by vehicle">';
    html += '<div class="ymm-home-fields">';
    
    fields.forEach(function(field, idx){
      var hiddenClass = idx >= activeVisibleFields ? ' hidden' : '';
      html += '<div class="ymm-home-field-wrap' + hiddenClass + '" id="ymm-field-wrap-' + idx + '">';
      html += '<label for="ymm-home-field-' + idx + '">' + field.label.toUpperCase() + '</label>';
      html += '<select id="ymm-home-field-' + idx + '" name="' + field.key + '" data-field-key="' + field.key + '" data-field-index="' + idx + '" aria-label="Select ' + field.label + '">';
      html += '<option value="">Select ' + field.label + '</option>';
      html += '</select>';
      html += '</div>';
    });
    
    /* ── Search Button ── */
    html += '<button class="ymm-home-btn" id="ymm-home-search-btn" type="submit" disabled>';
    html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>';
    html += '<span>' + config.buttonText + '</span>';
    html += '</button>';
    
    html += '</div>'; /* .ymm-home-fields */
    html += '</form>';
    html += '</div>'; /* .ymm-home-container */
    
    root.innerHTML = html;
    
    initializeFields(fields, savedSelection);
  }
  
  // Build multi-tag filter path: 9yy-year-2024+9yy-make-ford+9yy-model-f250-super-duty
  function buildTagPath(keys, selection){
    var tags = [];
    keys.forEach(function(key){
      var val = selection[key];
      if(val){
        var slug = String(val).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
        tags.push('9yy-' + key.toLowerCase() + '-' + slug);
      }
    });
    return tags.join('+');
  }

  function initializeFields(allFields, savedSelection){
    var selected = {};
    var fieldElements = [];
    
    allFields.forEach(function(field, idx){
      var el = document.getElementById('ymm-home-field-' + idx);
      if(el) fieldElements.push(el);
    });
    
    var shop = window.Shopify && window.Shopify.shop ? window.Shopify.shop : '';
    var vehiclesUrl = '/apps/ymm/vehicles?allFields=true' + (shop ? '&shop=' + encodeURIComponent(shop) : '');
    if(config.onlyWithFitments){
      vehiclesUrl += '&onlyWithFitments=true';
    }
    
    var vehiclesCacheKey = 'ymm_vtree_' + vehiclesUrl;

    /* Same read-through cache as the PDP/collection widgets: hydrate from
       sessionStorage when the tree was already fetched this session, fall
       back to the network (and populate the cache) otherwise. */
    function loadHomeVehicles(){
      try {
        var cached = sessionStorage.getItem(vehiclesCacheKey);
        if(cached){
          var parsed = JSON.parse(cached);
          if(parsed && (parsed.vehicles || Array.isArray(parsed))) return Promise.resolve(parsed);
        }
      } catch(e){}
      return fetch(vehiclesUrl)
        .then(function(response){
          if(!response.ok) throw new Error('Vehicles fetch failed');
          return response.json();
        })
        .then(function(data){
          try { sessionStorage.setItem(vehiclesCacheKey, JSON.stringify(data)); } catch(e){}
          return data;
        });
    }

    loadHomeVehicles()
      .then(function(data){
        var vehicles = Array.isArray(data) ? data : (data.vehicles || []);
        var fieldsMetadata = data.fields || [];

        // Extract required field keys for URL building
        var requiredFieldKeys = [];
        fieldsMetadata.forEach(function(f){
          if(f.required) requiredFieldKeys.push(f.key);
        });
        // Fallback: if no metadata, use all fields as required
        if(requiredFieldKeys.length === 0){
          allFields.forEach(function(f){ requiredFieldKeys.push(f.key); });
        }

        if(!vehicles || vehicles.length === 0){
          root.innerHTML = '<div class="ymm-home-error">No vehicles found. Please add vehicles in the app settings.</div>';
          return;
        }

        updateField(0, vehicles, {});

        // Initially disable all fields except the first one
        for(var i = 1; i < fieldElements.length; i++){
          fieldElements[i].disabled = true;
        }

        // Restore a saved vehicle into the dropdowns (pre-fill + cascade) so
        // returning to the home page shows the previously-entered vehicle.
        if(savedSelection && Object.keys(savedSelection).length){
          (function restoreSaved(idx){
            if(idx >= fieldElements.length) return;
            var el = fieldElements[idx];
            var key = el.dataset.fieldKey;
            var val = savedSelection[key];
            if(!val) return;
            var exists = Array.prototype.some.call(el.options, function(o){ return o.value === val; });
            if(!exists) return;
            el.value = val;
            el.disabled = false;
            selected[key] = val;
            var wrap = document.getElementById('ymm-field-wrap-' + idx);
            if(wrap) wrap.classList.remove('hidden');
            if(idx < fieldElements.length - 1){
              updateField(idx + 1, vehicles, selected);
              restoreSaved(idx + 1);
            }
          })(0);
          updateButton();
        }

        /* Cascade change listeners */
        fieldElements.forEach(function(el, idx){
          el.addEventListener('change', function(){
            var fieldKey = el.dataset.fieldKey;
            sessionStorage.removeItem('ymm_vehicle_selection');
            selected[fieldKey] = el.value;
            
            for(var i = idx + 1; i < fieldElements.length; i++){
              var nextEl = fieldElements[i];
              nextEl.innerHTML = '<option value="">Select ' + allFields[i].label + '</option>';
              nextEl.disabled = true;
              delete selected[nextEl.dataset.fieldKey];
              var fieldWrap = document.getElementById('ymm-field-wrap-' + i);
              if(fieldWrap && i > idx + 1 && i >= activeVisibleFields) fieldWrap.classList.add('hidden');
            }
            
            if(idx < fieldElements.length - 1){
              // Populate the next field and keep auto-filling while each
              // subsequent field has exactly one option.
              autoCascadeFrom(idx + 1);
            }

            updateButton();
          });
        });
        
        /* Search button handler */
        var btn = document.getElementById('ymm-home-search-btn');
        if(btn){
          btn.addEventListener('click', function(e){
            e.preventDefault();
            e.stopPropagation();
            
            var allFilled = allFields.every(function(field){
              return selected[field.key] && selected[field.key] !== '';
            });
            
            if(!allFilled) return;
            
            // Build multi-tag URL using only required fields
            var tagPath = buildTagPath(requiredFieldKeys, selected);
            var url = '/collections/' + config.collectionHandle + '/' + tagPath;
            
            // Only save required fields to localStorage (optional fields asked per PDP)
            var hadVehicle = sessionStorage.getItem('ymm_vehicle_selection');
            var cacheData = {};
            requiredFieldKeys.forEach(function(key){ if(selected[key]) cacheData[key] = selected[key]; });
            sessionStorage.setItem('ymm_vehicle_selection', JSON.stringify(cacheData));
            if (!hadVehicle) sessionStorage.setItem('ymm_source', 'home_search');
            
            // Apply button colors from settings
            var btnStyle = btn.style;
            btnStyle.setProperty('background', config.buttonColor);
            btnStyle.setProperty('color', config.buttonTextColor);
            
            // Track analytics
            fetch('/apps/ymm/search?shop=' + encodeURIComponent(shop) + '&trackSearch=true&source=home_search', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(cacheData),
              keepalive: true
            }).catch(function(){});
            
            window.location.href = url;
          });
        }
        
        function updateField(index, allVehicles, currentSelected){
          if(index >= fieldElements.length) return;
          var el = fieldElements[index];
          var field = allFields[index];
          var fieldKey = field.key;
          
          var filtered = allVehicles.filter(function(vehicle){
            for(var key in currentSelected){
              if(currentSelected[key] && vehicle[key] !== currentSelected[key]) return false;
            }
            return true;
          });
          
          var values = new Set();
          filtered.forEach(function(vehicle){ if(vehicle[fieldKey]) values.add(vehicle[fieldKey]); });
          
          var sortedValues = Array.from(values).sort(function(a, b){
            var aNum = parseFloat(a);
            var bNum = parseFloat(b);
            if(!isNaN(aNum) && !isNaN(bNum)) return bNum - aNum;
            return a.localeCompare(b);
          });
          
          el.innerHTML = '<option value="">Select ' + field.label + '</option>';
          sortedValues.forEach(function(value){
            var option = document.createElement('option');
            option.value = value;
            option.textContent = value;
            el.appendChild(option);
          });
          el.disabled = sortedValues.length === 0;
        }

        // Populate a field and, if it has exactly one option, auto-select it
        // and continue cascading to the next field (which may also auto-fill).
        function autoCascadeFrom(index){
          if(index >= fieldElements.length) return;
          updateField(index, vehicles, selected);
          var el = fieldElements[index];
          var wrap = document.getElementById('ymm-field-wrap-' + index);
          if(wrap) wrap.classList.remove('hidden');
          var realValues = [];
          for(var i = 0; i < el.options.length; i++){ if(el.options[i].value) realValues.push(el.options[i].value); }
          if(realValues.length === 1){
            el.value = realValues[0];
            selected[el.dataset.fieldKey] = realValues[0];
            autoCascadeFrom(index + 1);
          }
        }

        function updateButton(){
          var btn = document.getElementById('ymm-home-search-btn');
          if(!btn) return;
          var allFilled = allFields.every(function(field){
            return selected[field.key] && selected[field.key] !== '';
          });
          btn.disabled = !allFilled;
          
          // Apply button colors from settings
          if(config.buttonColor && config.buttonTextColor){
            btn.style.setProperty('background', config.buttonColor);
            btn.style.setProperty('color', config.buttonTextColor);
          }
        }
        
        updateButton();
      })
      .catch(function(error){
      });
  }
})();
